import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  AppBar,
  Box,
  Container,
  Menu,
  MenuItem,
  IconButton,
  Toolbar,
  Typography,
  ThemeProvider,
  Link
} from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import MenuIcon from '@mui/icons-material/Menu';
import LanguageIcon from '@mui/icons-material/Language';
// import BottomNavigation from '@mui/material/BottomNavigation';
import { useSelector } from "react-redux";
import { useTheme } from "@mui/material";

import 'modules/root/i18n';

import { selectIsBusiness } from 'modules/survey/reducer';

import { tele2Theme } from 'theme/tele2-theme';
import { altelTheme } from 'theme/altel-theme';
import { fmobileTheme } from 'theme/fmobile-theme';
import SurveyContainer from 'modules/survey';

const brandDetails = {
  tele2: {
    url: 'https://tele2.kz',
    name: 'Tele2',
    phones: [
      {
        order: 1,
        href: 'tel:116',
        phoneDisplay: '116',
        isBusiness: false,
      },
      {
        order: 2,
        href: 'tel:611',
        phoneDisplay: '611',
        isBusiness: false,
      },
      {
        order: 3,
        href: 'tel:+77070000707',
        phoneDisplay: '+7 707 000 07 07',
        isBusiness: false,
      },
      {
        order: 4,
        href: 'tel:636',
        phoneDisplay: '636',
        isBusiness: true,
      },
      {
        order: 5,
        href: 'tel:+77073550033',
        phoneDisplay: '+7 707 355 00 33',
        isBusiness: true,
      }
    ],
    theme: tele2Theme
  },
  altel: {
    url: 'https://altel.kz',
    name: 'Altel',
    phones: [
      {
        order: 1,
        href: 'tel:116',
        phoneDisplay: '116',
        isBusiness: false,
      },
      {
        order: 2,
        href: 'tel:611',
        phoneDisplay: '611',
        isBusiness: false,
      },
      {
        order: 3,
        href: 'tel:+77008000880',
        phoneDisplay: '+7 700 800 08 80',
        isBusiness: false,
      },
      {
        order: 4,
        href: 'tel:636',
        phoneDisplay: '636',
        isBusiness: true,
      },
      {
        order: 5,
        href: 'tel:+77083305858',
        phoneDisplay: '+7 708 330 58 58',
        isBusiness: true,
      },
    ],
    theme: altelTheme
  },
  fmobile: {
    url: 'https://5gmobile.kz',
    name: 'Five Mobile',
    phones: [
      // {
      //   order: 1,
      //   href: 'tel:116',
      //   phoneDisplay: '116',
      //   isBusiness: false,
      // },
      // {
      //   order: 2,
      //   href: 'tel:611',
      //   phoneDisplay: '611',
      //   isBusiness: false,
      // },
      {
        messenger: 'whatsapp',
        order: 3,
        // href: 'https://wa.me/+77470005757',
        href: 'https://api.whatsapp.com/send/?phone=77470005757&text&type=phone_number&app_absent=0',
        phoneDisplay: '+7 747 000 57 57',
        isBusiness: false,
      }
    ],
    theme: fmobileTheme
  },
};

function App() {
  const { t, i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const selectLanguage = (language) => {
    localStorage.i18nextLng = language;
    i18n.changeLanguage(language);

    handleMenuClose();
  }
  const { hostname } = window.location;
  // const isTele2 = hostname.includes("tele2");

  const brand = hostname.includes("tele2") ? "tele2" : (hostname.includes("altel") ? "altel" : "fmobile");
  // const brand = "altel";
  const isBusiness = useSelector(selectIsBusiness);

  const theme = brandDetails[brand]?.theme;

  // useEffect(() => {
  //   const { language } = i18n;

  //   if (!['kz', 'ru'].includes * (language)) {
  //     // localStorage.i18nextLng
  //     selectLanguage('kz');
  //   }
  // }, []);

  const isMenuOpen = Boolean(anchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const menuId = 'primary-language-selector';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={() => selectLanguage('kz')} data-value='kz'>Қазақ</MenuItem>
      <MenuItem onClick={() => selectLanguage('ru')} data-value='ru'>Русский</MenuItem>
      {/* <MenuItem onClick={() => selectLanguage('en')} data-value='en'>English</MenuItem> */}
    </Menu>
  );

  return (
    // <ThemeProvider theme={tele2Theme}>
    // <ThemeProvider theme={isTele2 ? tele2Theme : altelTheme}>
    <ThemeProvider theme={theme}>
      <AppBar position="static">
        <Toolbar variant="dense">
          <IconButton edge="start" aria-label="menu" sx={{ mr: 2 }} style={{ padding: 0 }}>
            {/* <MenuIcon /> */}
            {/* <img src='/tele2_original.svg' height='30px' /> */}
            {/* {isTele2 ?
              (<img src='images/white_logo.png' height='50px' />) :
              (<img src='images/altel-logo-reverse.png' width='120px' />)
            } */}
            {brand === "tele2" && <img src='images/white_logo.png' height='50px' />}
            {brand === "altel" && <img src='images/altel-logo-reverse.png' width='120px' />}
            {brand === "fmobile" && <img src='images/fmobile-logo-reverse.svg' width='120px' />}
          </IconButton>
          {/* <Typography variant="h6" color="inherit" component="div">
              {t('title')}
            </Typography> */}
          <Box sx={{ flexGrow: 1 }} />
          {/* <Box sx={{ display: { xs: 'none', md: 'flex' } }}> */}
          <Box sx={{ display: 'flex' }}>
            <IconButton
              size="large"
              edge="end"
              aria-label="current language"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <LanguageIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      {renderMenu}
      <div style={{ display: 'flex', flexDirection: 'column', alignContent: 'space-around', height: 'calc(100% - 48px)' }}>
        <div style={{ flex: 1 }}>
          <Container style={{ height: '100%' }}>
            <SurveyContainer
              selectLanguage={selectLanguage}
            />
          </Container>
        </div>
        <Footer
          // isTele2={isTele2}
          brand={brand}
          isBusiness={isBusiness}
        />
      </div>
    </ThemeProvider >
  );
}

// const Footer = ({ isTele2 }) => {
const Footer = ({ brand, isBusiness }) => {
  const { palette } = useTheme();
  const { primary: { contrastText, main } } = palette;
  // console.log('!palette', palette)
  const phones = brandDetails[brand]?.phones?.filter(ph => isBusiness === (ph.isBusiness ?? false));

  return (
    <div style={{ flexBasis: '150px', backgroundColor: main }}>
      <Container style={{ height: '100%' }}>
        <div style={{ color: contrastText, padding: 10 }}>
          <Contacts phones={phones} contrastText={contrastText} />
          <div style={{
            // color: 'white'
            color: contrastText,
            // fontSize: 16
          }}>
            {/* {new Date().getFullYear()} © <Link color={contrastText} href={isTele2 ? 'https://tele2.kz' : 'https://altel.kz'} target={'_blank'} type='te'>{isTele2 ? 'Tele2' : 'Altel'}</Link> */}
            {new Date().getFullYear()} © <Link color={contrastText} href={brandDetails[brand].url} target={'_blank'} type='te'>{brandDetails[brand].name}</Link>
            {/* Лицензия АБА № 000950 выдана АИС РК
            Начиная с 28 июня 2019 г., ТОО "Мобайл Телеком-Сервис" больше не принадлежит и не является аффилированным лицом Tele2 Sverige AB или любого из аффилированных лиц такой компании.
            Товарный Знак и бренд Tele2 используется на основании лицензии, предоставленной Tele2 Sverige AB */}
          </div>
        </div>

      </Container >
    </div >
  );
}

const Contacts = ({ phones, contrastText }) => {

  const { t, i18n } = useTranslation();

  const len = phones.length;
  const phoneLinks = phones.sort((ph1, ph2) => ph1.order - ph2.order).map((ph, idx) => {
    return (
      <span
        key={ph.phoneDisplay}
        style={{ alignItems: 'center', minHeight: '20px', display: 'inline-flex' }}
      >
        {ph.messenger === 'whatsapp' && <WhatsAppIcon />}
        <Link key={idx} color={contrastText} href={ph.href} target={'_blank'} type='te'>{ph.phoneDisplay}</Link> {idx < len - 1 ? '| ' : ''}
      </span>
    )
  });

  return (
    <div style={{ color: contrastText, fontSize: 16 }}>
      <strong style={{ color: contrastText }}>{t('contactCenter')}:</strong>
      <br />
      {phoneLinks}
      <br />
      {t('subscriberService')}
      <br />
      <br />
      {/* Сайт: <Link color={contrastText} href='https://tele2.kz'>Tele2</Link> */}
      <br />
      <br />
    </div>)
}

export default App;
